import { Jodit } from "jodit";

(window as any).initJoditEditor = function (selector: string, options = {}) {
    const textareas = document.querySelectorAll(
        selector,
    ) as NodeListOf<HTMLTextAreaElement>;
    textareas.forEach((textarea) => {
        if (!textarea.classList.contains(`jodit-initialized`)) {
            Jodit.make(
                textarea as any,
                {
                    minHeight: 300,
                    askBeforePasteFromWord: false,
                    askBeforePasteHTML: false,
                    cleanHTML: {
                        removeEmptyElements: false,
                        fillEmptyParagraph: false,
                        replaceNBSP: false,
                        denyTags: `script,img`,
                    },
                    placeholder: `Пишите...`,
                    enter: `br`,
                    removeButtons: [`image`],
                    ...options,
                } as any,
            );

            textarea.classList.add(`jodit-initialized`);
        }
    });
};
